import React, { Component } from 'react'
import Img from 'gatsby-image'
import styled from 'styled-components'
import Link from 'gatsby-link'
import * as Styles from '../assets/_styles'
import CaseListing from '../components/CaseListing'

const PageContainer = styled.div`
  width: 100vw;
  font-size: 12pt;
  padding: 80px 8px 0;

  ${Styles.media.tablet`font-size: 10pt; padding: 80px 32px 0;`};
`

const Logo = styled.div`
  margin: auto;
  text-align: center;
  padding: 0 0 40px 0;
  img {
    max-width: 200px;
    filter: grayscale(1), brightness(2);
  }
`

const PostContainer = styled.div`
  margin: 0 auto;
  position: relative;
  max-width: 780px;
  z-index: 2;
  color: #fff;
  h1,
  h3 {
    text-align: center;
  }

  h1 {
    font-weight: 500;
    font-size: 3.5em;
    line-height: 1.3;
    margin-top: 0;
    margin-bottom: 40px;
    ${Styles.media.tablet`font-size: 2.5em;`};
  }

  h3 {
    font-size: 1.6em;
    font-weight: 300;
    line-height: 1.5;
    ${Styles.media.tablet`font-size: 1.25em;`};
  }
`

const Hero = styled.div`
  display: flex;
  align-items: center;
  padding: 40px 0 120px;
`

const PostContent = styled.div`
  max-width: 780px;
  margin: 80px auto;
  line-height: 1.7;
  font-size: 1.2em;
  > p:first-of-type::first-letter {
    font-size: 200%;
    padding-right: 2px;
    line-height: 0.9em;
  }
  p {
    margin-bottom: 1.5em;
  }
`

class CaseStudyLayout extends Component {
  constructor(props) {
    super(props)
    this.state = { heroHeight: 0 }
  }

  componentDidMount() {
    this.setState({
      heroHeight: document.getElementById('heroContent').offsetHeight + 80,
    })
    window.addEventListener('resize', () => {
      this.setState({
        heroHeight: document.getElementById('heroContent').offsetHeight + 80,
      })
    })
  }

  render() {
    console.log(this.props)
    const post = this.props.data.markdownRemark
    return (
      <PageContainer>
        <Hero id="heroContent">
          <ImageContainer height={this.state.heroHeight}>
            <Img sizes={post.frontmatter.background.childImageSharp.sizes} />
          </ImageContainer>
          <PostContainer>
            <Logo>
              <img src={post.frontmatter.logo.childImageSharp.original.src} />
            </Logo>
            {/* <h1>{post.frontmatter.company}</h1> */}
            <h3>{post.frontmatter.subtitle}</h3>
          </PostContainer>
        </Hero>
        <PostContent dangerouslySetInnerHTML={{ __html: post.html }} />
        <PostContent>
          Sound interesting?{' '}
          <Link to="/#contact" style={{ textDecoration: 'underline' }}>
            Get in touch.
          </Link>
        </PostContent>
      </PageContainer>
    )
  }
}

export default CaseStudyLayout

export const caseStudyQuery = graphql`
  query BlogPostQuery($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      ...CaseListingFragment
    }
  }
`

const ImageContainer = styled.div`
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  filter: brightness(0.5);
  height: ${props => `${props.height}px` || `auto`};
  > * {
    object-fit: cover;
  }
  .gatsby-image-outer-wrapper,
  .gatsby-image-wrapper {
    height: 100%;
  }
`



// WEBPACK FOOTER //
// ./src/layouts/CaseStudyLayout.js